import type { ImportTemplateParams } from './types';
import type { ReviewQuestionnaire } from '@/types/review/ReviewQuestionnaire';

import { api } from '@/api/api';
import { filterOutOtherOption } from '@/utils/question';

export default {
    async getReviewQuestionnaire(reviewQuestionnaireId: string): Promise<ReviewQuestionnaire> {
        const response = await api.get(`/reviewquestionnaire/${reviewQuestionnaireId}`);

        return response.data;
    },

    async updateReviewQuestionnaire(
        reviewQuestionnaire: ReviewQuestionnaire,
        signal?: AbortSignal,
    ): Promise<ReviewQuestionnaire> {
        const payload: ReviewQuestionnaire = {
            ...reviewQuestionnaire,
            reviewQuestions: reviewQuestionnaire.reviewQuestions.map((question) => ({
                ...question,
                reviewQuestionOptions: filterOutOtherOption(question.reviewQuestionOptions),
            })),
        };
        const response = await api.put(`/reviewquestionnaire/${reviewQuestionnaire.id}`, payload, {
            signal,
        });
        return response.data;
    },

    async importTemplate({
        questionnaireId,
        templateId,
    }: ImportTemplateParams): Promise<ReviewQuestionnaire> {
        const response = await api.post(`/reviewquestionnaire/${questionnaireId}/importtemplate`, {
            templateId,
        });

        return response.data;
    },
};
